// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgViewView24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_18342_280265)">
					<path d="M11.7283 7.76074H11.7066C8.55438 7.76074 5.59786 9.35857 2.92395 12.5107C2.71743 12.7499 2.69569 13.0977 2.8696 13.3586C3.02177 13.5868 6.59786 18.902 11.8479 19.0542C11.9239 19.0542 12 19.0542 12.0761 19.0542C15.25 19.0542 18.2826 17.152 21.0979 13.3912C21.2935 13.1303 21.2826 12.7607 21.0761 12.5107C20.9131 12.3151 17.0435 7.77161 11.7283 7.76074ZM15.8913 13.4129C15.8913 15.5542 14.1522 17.3042 12 17.3042C9.85873 17.3042 8.10873 15.5651 8.10873 13.4129C8.10873 11.2607 9.84786 9.52161 12 9.52161C14.1413 9.52161 15.8913 11.2607 15.8913 13.4129ZM4.3696 13.0107C5.4783 11.7825 6.63047 10.8477 7.81525 10.2064C7.13047 11.0977 6.70656 12.1955 6.70656 13.4129C6.70656 14.3368 6.96743 15.1955 7.38047 15.9564C5.93482 14.9129 4.8696 13.6629 4.3696 13.0107ZM16.587 16.0107C17.0326 15.239 17.3044 14.3586 17.3044 13.402C17.3044 12.3477 16.9892 11.3803 16.4566 10.5542C17.9457 11.402 19.0653 12.4347 19.6196 12.9999C18.6305 14.2607 17.6196 15.2499 16.5979 15.9999L16.587 16.0107Z" />
					<path d="M12 6.55435C12.3913 6.55435 12.7065 6.23913 12.7065 5.84783V3.70652C12.7065 3.31522 12.3913 3 12 3C11.6087 3 11.2935 3.31522 11.2935 3.70652V5.84783C11.2935 6.23913 11.6087 6.55435 12 6.55435Z" />
					<path d="M21.7935 6.45673C21.5218 6.18499 21.0653 6.18499 20.7935 6.45673L19.2827 7.9676C19.0109 8.23934 19.0109 8.69586 19.2827 8.9676C19.424 9.10891 19.5979 9.17412 19.7827 9.17412C19.9674 9.17412 20.1414 9.10891 20.2827 8.9676L21.7935 7.45673C22.0653 7.18499 22.0653 6.72847 21.7935 6.45673Z" />
					<path d="M4.21736 9.17412C4.40214 9.17412 4.57606 9.10891 4.71736 8.9676C4.9891 8.69586 4.9891 8.23934 4.71736 7.9676L3.20649 6.45673C2.93475 6.18499 2.47823 6.18499 2.20649 6.45673C1.93475 6.72847 1.93475 7.18499 2.20649 7.45673L3.71736 8.9676C3.85866 9.10891 4.03258 9.17412 4.21736 9.17412Z" />
					<path d="M12.0001 15.1301C12.9458 15.1301 13.7175 14.3584 13.7175 13.4127C13.7175 12.4671 12.9458 11.6953 12.0001 11.6953C11.0545 11.6953 10.2827 12.4671 10.2827 13.4127C10.2827 14.3584 11.0545 15.1301 12.0001 15.1301Z" />
				</g>
				<defs>
					<clipPath id="clip0_18342_280265">
						<rect width={20} height={16.0543} transform="translate(2 3)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgViewView24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgViewView24;
